import ManagementPage from '@/views/restricted/management/ManagementPage.vue'
import DistributorLayout from '@/layouts/DistributorLayout.vue'
import EditAccountPage from '@/views/restricted/management/account/EditAccountPage.vue'
import DetailAccountPage from '@/views/restricted/management/account/DetailAccountPage.vue'
import CreateCollaboratorPage from '@/views/restricted/management/collaborator/CreateCollaboratorPage.vue'
import EditCollaboratorPage from '@/views/restricted/management/collaborator/EditCollaboratorPage.vue'
import AddCollaboratorPage from '@/views/login/restricted/collaborator/AddCollaboratorPage.vue'

export default [
  {
    path: '/accounts',
    name: 'Accounts',
    menuSelected: 'accounts',
    component: ManagementPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ACCOUNT_READ_PERMISSION']
    }
  },
  {
    path: '/accounts/update/:accountId',
    name: 'EditAccount',
    menuSelected: 'accounts',
    component: EditAccountPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ACCOUNT_UPDATE_PERMISSION']
    }
  },
  {
    path: '/accounts/detail/:accountId',
    name: 'DetailAccount',
    menuSelected: 'accounts',
    component: DetailAccountPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ACCOUNT_READ_PERMISSION']
    }
  },
  {
    path: '/accounts/:accountId/collaborator/new',
    name: 'CreateCollaborator',
    component: CreateCollaboratorPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_ADD_COLLABORATOR']

    }
  },
  {
    path: '/accounts/:accountId/collaborator/update/:collaboratorId',
    name: 'EditCollaborator',
    component: EditCollaboratorPage,
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      permissions: ['DISTRIBUTOR_UPDATE_COLLABORATOR']

    }
  },
  {
    path: '/add-collaborator',
    name: 'AddCollaborator',
    component: AddCollaboratorPage,
    meta: {
      requiresAuth: true,
      permissions: ['DISTRIBUTOR_ADD_COLLABORATOR']
    }
  }
]
